import { UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { CURRICULUM_MASTER } from "../apiRoutes";

// Define the expected response type
interface CurriculumMaster {
  moduleId: string;
  subModuleId: string;
  curriculumTopic: string;
  academicYear: number;
  applicableGrades: string[];
  activityType: string;
  topicTLM: string;
  description: string;
  createdAt: string;
  isActive: boolean;
}

interface CurriculumMasterResponse {
  data: {
    records: CurriculumMaster[];
    pagination: { totalRecords: number }[];
  }[];
}

const fetchCurriculumMaster = async ({ data }: { data: FieldValues }) => {
  const response = await axiosAuth.get<CurriculumMasterResponse>(CURRICULUM_MASTER, {
    params: data,
  });
  return response.data;
};

// Query hook
const useCurriculumMasterQuery = (
  data: FieldValues,
  queryParams?:
    | UseQueryOptions<CurriculumMasterResponse, Error, CurriculumMasterResponse, ["curriculumMaster", FieldValues]>
    | UseMutationOptions<any, Error>
) =>
  useQuery<CurriculumMasterResponse, Error, CurriculumMasterResponse, ["curriculumMaster", FieldValues]>({
    queryKey: ["curriculumMaster", data],
    queryFn: () => fetchCurriculumMaster({ data }),
    ...(queryParams as any), // safely spread because TS can't know if it's query or mutation
  });

export default useCurriculumMasterQuery;
